{
  "ec": {
    "v_current": "int",
    "v_temp": "int",
    "v_max": "int",
    "v_max_temp": "int",
    "encounter_creature_dead": "int",
    "encounter_creature_deleted": "int",
    "preferred_speed_type": "uuid",
    "mana": "int",
    "luck": "int",
    "aps": "int",
    "aps_total": "int",
    "weapon_attack": "int",
    "head_attack": "int",
    "reaction": "int",
    "hunger_meter_current": "int",
    "thirst_meter_current": "int",
    "creature_initiative": "int",
    "x_pos": "float",
    "y_pos": "float",
    "z_pos": "float",
    "movement_pct": "float",
    "orb_queue": "queue"
  }
}
